import { Controller } from 'stimulus';

class MapController extends Controller {
  connect() {
    this.createMap();
  }

  createMap() {
    if (typeof window.mapboxgl === 'undefined') {
      setTimeout(() => {
        this.createMap();
      }, 5000);
      return;
    }

    window.mapboxgl.accessToken = this.data.get('token');

    this.map = new window.mapboxgl.Map({
      container: this.element,
      style: 'mapbox://styles/mapbox/streets-v11',
      center: [
        this.data.get('longitude'),
        this.data.get('latitude'),
      ],
      zoom: this.data.get('zoom'),
      minZoom: 7,
      maxZoom: 18,
    });

    const marker = this.createMarker();
    marker.addTo(this.map);
  }

  createMarker() {
    const el = document.createElement('div');
    el.className = 'marker';
    el.style.backgroundImage = 'url(/front_assets/img/map-pin.svg)';
    el.style.width = '42px';
    el.style.height = '57px';
    el.style.backgroundSize = '100%';

    return new window.mapboxgl.Marker({
      anchor: 'bottom',
      element: el,
    })
      .setLngLat([
        this.data.get('longitude'),
        this.data.get('latitude'),
      ]);
  }
}

MapController.targets = [
  //
];

export default MapController;
